<template>
    <form @submit.prevent="StoreData" method="post">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="card mb-3 shadow">
                    <div class="card-header bg-gradient-primary">
                        <h4 class="card-title text-white">Pemohon</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label>Nama</label>
                            <input type="text" class="form-control" v-model="data.nama">
                        </div>
                        <div class="form-group mb-3">
                            <label>Intansi / Perusahaan</label>
                            <input type="text" class="form-control" v-model="data.instansi">
                        </div>
                        <div class="form-group mb-3">
                            <label>No Telepon / Hp</label>
                            <input type="text" class="form-control" v-model="data.nohp">
                        </div>
                        <div class="form-group mb-3">
                            <label>Tanggal</label>
                            <input type="date" class="form-control" v-model="data.tanggal">
                        </div>
                        <div class="form-group mb-3">
                            <label>Paket Pekerjaan</label>
                            <input type="text" class="form-control" v-model="data.paket_pekerjaan">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="card mb-3 shadow">
                    <div class="card-header bg-gradient-primary">
                        <h4 class="card-title text-white">Informasi</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label>No Dokumen</label>
                            <input type="text" class="form-control" v-model="data.no_dok">
                        </div>
                        <div class="form-group mb-3">
                            <label>No Revisi</label>
                            <input type="text" class="form-control" v-model="data.no_revisi">
                        </div>
                        <div class="form-group mb-3">
                            <label>Halaman</label>
                            <input type="text" class="form-control" v-model="data.halaman">
                        </div>
                        <div class="form-group mb-3">
                            <label>Tanggal Terbit</label>
                            <input type="date" class="form-control" v-model="data.tgl_terbit">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between">
            <owl-delete-button :url="'pengajuan/' + this.id" redirectUrl="ujilab.penerimaan">Hapus</owl-delete-button>
            <div>
                <a :href="this.baseUrl + 'api/pengajuan/' + this.id" class="btn bg-gradient-info">Cetak</a>
                <button type="submit" class="ms-3 btn bg-gradient-primary">Terima Pengajuan</button>
            </div>
        </div>
    </form>
</template>

<script>
import OwlDeleteButton from '@/components/OwlDeleteButton.vue';
export default {
    name: "UserPengujianForm",
    components: { OwlDeleteButton },
    data() {
        return {
            id: this.$route.params.id,
            baseUrl: process.env.VUE_APP_URL,
            data: {},
        }
    },
    methods: {
        StoreData() {
            this.axios.post('penerimaan/' + this.id, this.data).then((response) => {
                const jumlahUsulan = response.data.data.r_usulan.length;
                var updatedUsulan = 0;
                this.data.r_usulan.forEach((usulan) => {
                    if (usulan.status == 'Pengajuan') {
                        this.axios.post('update-status-usulan', { usulan_id: usulan.id, message: 'Diterima' }).then(() => {
                            updatedUsulan++;
                        });
                    } else {
                        updatedUsulan++;
                    }
                });

                if (jumlahUsulan == updatedUsulan) {
                    this.$swal.fire({
                        icon: 'success',
                        title: response.data.message,
                    }).then(() => {
                        this.$router.push({ name: 'ujilab.penerimaan' });
                    });
                }
            });

        }
    },
    mounted() {
        this.axios.get('pengajuan/' + this.id).then((response) => {
            this.data = response.data.data;
        });
    }
}
</script>